<template>
  <div class="channel">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/changjing/j"
      :key="key"
      @before-fetch="beforeFetch"
      @after-fetch="afterFetch"
    >
      <el-table-column slot="channel" label="渠道栏目" :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row | convertChannel}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="scale" label="流量规模" :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.scale}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="how" label="合作方式" :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.how}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="price" label="商务价格" :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.price}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="scale2" label="合作流量规模" :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.scale2}}</span>
        </template>
      </el-table-column>
       <el-table-column slot="responsor2" label="运营负责人"  :show-overflow-tooltip="true" width="140">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.responsor2}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" :width="previllage === 2 || previllage === 10 ? 180 : 60" fixed="right">
        <template v-slot="{row}">
           <el-button
            v-if="permissionFn('write')"
            type="text"
            @click="goToEditContact(row)"
          >名片</el-button>
          <el-button type="text" @click="detail(row.id)">详情</el-button>
          <el-button
            v-if="permissionFn('write')"
            type="text"
            @click="goToEdit(row)"
          >编辑</el-button>
          <el-button
            v-if="permissionFn('admin')"
            type="text"
            @click="remove(row, $event)"
          >删除</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import permissionMixins from '@/mixins/permission'
export default {
  components: { CTable },
  mixins: [permissionMixins],
  data() {
    return {
      loading: false,
      fields: [
        {
          prop: 'name',
          placeholder: '关键词',
          clearable: true
        },
        {
          prop: 'channel',
          placeholder: '栏目',
          component: 'cascader',
          options: this.$store.state.global.channels,
          clearable: true,
          filterable: true,
          'checkStrictly': true,
          props: { checkStrictly: true },
          value: []
        },
        {
          prop: 'status',
          placeholder: '状态',
          component: 'select',
          options: ['合作中', '测试中', '暂停中', '淘汰退出', '待测试'].map(x => {
            return {
              value: x,
              label: x
            }
          }),
          clearable: true,
          filterable: true,
          value: ''
        }
      ],
      columns: [
        { prop: 'name', label: '渠道名', width: 200 },
        { slot: 'channel', label: '渠道栏目' },
        { slot: 'scale', label: '流量规模' },
        { slot: 'how', label: '合作方式' },
        { slot: 'price', label: '商务价格' },
        { slot: 'scale2', label: '合作流量规模' },
        { prop: 'status', label: '当前合作状态', width: 115 },
        { slot: 'responsor2', label: '运营负责人' },
        { prop: 'responsor', label: '商务负责人', minWidth: 100 },
        { slot: 'caozuo' }
      ],
      key: Date.now(),
      previllage: 1
    }
  },
  watch: {
    '$route': {
      handler(val, oldVal) {
        if (!oldVal || (oldVal && !oldVal.fullPath.includes('changjing/edit'))) {
          const { active, id, status, name } = val.query
          if (+active === 1) {
            if (name && name !== 'undefined') {
              this.fields[0].value = name
            }
            if (id) {
              this.fields[1].value = id.split('-').map(x => +x)
              this.fields[2].value = status ? {
                run: '合作中',
                test: '测试中',
                pause: '暂停中',
                quit: '淘汰退出',
                wait: '待测试'
              }[status] : ''
            } else {
              this.fields[1].value = []
              this.fields[2].value = ''
            }
            this.key = Date.now()
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    isSafria() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('safari/') > -1 && ua.indexOf('chrome/') === -1
    }
  },
  methods: {
    beforeFetch(params) {
      [params.first, params.second] = params.channel
      delete params.channel
    },
    afterFetch(res) {
      this.previllage = res.data.previllage
    },
    detail(id) {
      window.open(`/changjing/detail/${id}`)
    },
    remove (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.name,
        operate: () =>
          this.$http.post(`/changjing/jdelete`, {
            id: row.id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    },
    // 去编辑页面，需要新窗口打开
    goToEdit(row) {
      window.open(`/changjing/edit/${row.id}`)
    },
    // 去编辑页面，需要新窗口打开
    goToEditContact(row) {
      window.open(`/changjing/edit_contact/${row.id}`)
    }
  }
}
</script>

<style lang="scss">
.channel{
  .overflow{
    text-overflow: ellipsis;
    width:110px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
